import React from "react";
import { Section } from "../../../atoms/section";
import { Header } from "../../../molecules/header";
import { Flex } from "../../../atoms/flex";
import { useStore } from "../../../../store";
import { SECTIONS } from "../../../../constants/sections";
import { SavingsListItem } from "../../../molecules/savings-list-item";
import { Graph } from "../../../molecules/graph";
import { Wave } from "../../../atoms/wave";
import { UNITS } from "../../../../constants/units";

/**
 * Economy section component
 */
export const Economy = () => {
  const { data, loading } = useStore();

  const getYears = (years?: number) => {
    if (!years) {
      return "NaN";
    }

    if (years > 15) {
      return ">15y";
    }

    if (years < 1) {
      return `${Math.round(years * 365)}d`;
    }

    return `${Math.round(years)}y`;
  };

  return (
    <>
      <Wave className="fill-gray" variant={2} />
      <Section className="bg-gray" id={SECTIONS.ECONOMY} wave>
        <Header
          icon="money"
          title={SECTIONS.ECONOMY}
          subTitle={`En ${data?.economicPercentage?.toFixed(0) || ""}${
            UNITS.PERCENT
          } besparing på ${data?.economicSavings?.toFixed(0) || ""}${
            UNITS.KR
          }  sedan installation.`}
          loading={loading}
        ></Header>
        <Flex className="section-content">
          <Graph
            description="Tvättkostnad"
            max={data?.costsWithoutAMimbox}
            min={data && data?.costsWithoutAMimbox - data?.economicSavings}
            unit={UNITS.KR}
            loading={loading}
          />
          <Flex className="savings-list">
            <SavingsListItem
              text="Vattenbesparingen som gjorts av Mimboxen."
              value={data?.waterSavedM3?.toFixed(2) || ""}
              unit={UNITS.CUBIC}
              loading={loading}
            />
            <SavingsListItem
              text="El som sparats på grund av att värmen bevarats i vattnet
                    som återanvänds."
              value={data?.energySaved?.toFixed(2)}
              unit={UNITS.KWH}
              loading={loading}
            />
            <SavingsListItem
              text="Är beräknad återbetalingstid med dagens vatten och
                    elpriser."
              value={getYears(data?.roiYears)}
              unit={UNITS.ROI}
              loading={loading}
            />
          </Flex>
        </Flex>
      </Section>
    </>
  );
};
